declare const gaGlobal: {
	vid: "string";
};

/**
 * Simulates a text field change event.
 *
 * @param selector The selector of the field to change.
 * @param value The value to set the field to.
 */
function injectField(selector: string, value: string): void {
	const fields = document.querySelectorAll<HTMLInputElement>(selector);
	fields.forEach((linker) => {
		if (linker.nodeName === "INPUT") {
			linker.type = "hidden";
		}
		linker.value = value;
		const event = new Event("change", { bubbles: true });
		linker.dispatchEvent(event);
	});
}

/** Sets the sales rep field to the value in the URL. */
function setRep(): void {
	const fieldSelector = ".sales-rep";
	const { href } = window.location;
	const cleanedURL = href.replace(/\?cardCode=[a-z0-9]*/gi, "");
	const url = new URL(cleanedURL);
	const salesRep = url.searchParams.get("rep");
	const repSelect = document.querySelector(fieldSelector) as HTMLSelectElement;
	if (!salesRep || !repSelect) return;

	const emailMappings = new Map();
	for (const option of repSelect.children) {
		emailMappings.set(option.textContent, (option as HTMLOptionElement).value);
	}
	const value = emailMappings.get(salesRep);
	if (!value) return;
	injectField(fieldSelector, value);
	const parentContainer = repSelect.closest(".nf-field") as HTMLDivElement;
	if (!parentContainer) return;
	parentContainer.style.display = "none";
}

/** Injects the analytics ID into the form. */
function injectAnalyticsID(): void {
	const id = (typeof gaGlobal !== "undefined" && gaGlobal?.vid) || "Not Set";
	injectField('[name="rt-analytics-input"]', id);
	injectField('[name="rtanalyticsinput"]', id);
}

/**
 * Attaches a mutation observer to the form.
 *
 * @param formSelector The selector of the form to observe.
 */
function attachObserver(formSelector: string): void {
	const target = document.querySelector(formSelector);
	if (!target) return;
	const config = { childList: true };
	const observer = new MutationObserver(setRep);
	observer.observe(target, config);
}

/** Initializes the tracking script. */
export default function (): void {
	attachObserver(".nf-form-cont");
	//Give GA a chance to finish its stuff
	setTimeout(injectAnalyticsID, 10000);
}
